import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface EmissionsIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const EmissionsIcon = ({ color = RoutalPalette.white, style = {}, ...props }: EmissionsIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 18" style={{ width: `20px`, height: `18px`, ...style }}>
      <g>
        <path
          d="M1.66772 0.460205C0.746672 0.460205 0 1.20686 0 2.12792V6.41839C0 9.70899 2.66756 12.3765 5.95818 12.3765C6.02715 12.3765 6.09584 12.3754 6.16425 12.3731C5.87288 11.5516 5.71429 10.6673 5.71429 9.74593C5.71429 8.96829 5.82727 8.21703 6.03769 7.50767L4.49494 5.96536C4.21595 5.68646 4.21589 5.2342 4.49479 4.95521C4.77369 4.67623 5.22597 4.67615 5.50495 4.95507L6.62362 6.07343C7.45978 4.49482 8.81817 3.23535 10.4686 2.52519C9.37607 1.26053 7.76058 0.460205 5.95818 0.460205H1.66772Z"
          fill={color}
        />
        <path
          d="M8.54907 13.7593L6.00199 16.3083C5.72315 16.5874 5.72332 17.0395 6.00236 17.3184C6.28142 17.5973 6.73368 17.5971 7.01252 17.3181L9.55937 14.7693C10.659 15.6487 12.0538 16.1745 13.5713 16.1745C17.1217 16.1745 19.9999 13.2964 19.9999 9.74596V5.07063C19.9999 4.10234 19.2149 3.31738 18.2466 3.31738H13.5713C10.0209 3.31738 7.14272 6.19556 7.14272 9.74596C7.14272 11.2642 7.66899 12.6594 8.54907 13.7593ZM14.0807 10.2445L10.5757 13.7495C10.1928 13.4627 9.8525 13.1221 9.56581 12.7391L13.0706 9.23436C13.3496 8.95542 13.8017 8.95542 14.0807 9.23436C14.3597 9.51332 14.3597 9.96558 14.0807 10.2445Z"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
};
